import { IEditSubcategoryRestaurantPropertiesState } from './editSubcategoryRestaurantPropertiesContext';
import {
	TEditSubcategoryRestaurantPropertiesAction,
	EditSubcategoryRestaurantPropertiesActionTypes,
} from './editSubcategoryRestaurantPropertiesActions';

export const editSubcategoryRestaurantPropertiesReducer = (
	state: IEditSubcategoryRestaurantPropertiesState,
	action: TEditSubcategoryRestaurantPropertiesAction,
): IEditSubcategoryRestaurantPropertiesState => {
	switch (action.type) {
		case EditSubcategoryRestaurantPropertiesActionTypes.REFETCH_REST_PROPS_DATA:
			return {
				...state,
				needRefetchRestPropsData: action.payload.needRefetchRestPropsData,
			};
		case EditSubcategoryRestaurantPropertiesActionTypes.SET_ALL_DATA:
			return {
				...state,
				subcategoryId: action.payload.subcategoryId,
				subcategoryName: action.payload.subcategoryName,
				customerName: action.payload.customerName,
				categoryName: action.payload.categoryName,
				hasSchedulePriority: action.payload.hasSchedulePriority,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditSubcategoryRestaurantPropertiesActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				dishes: action.payload.dishes,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				availableForRepetition: action.payload.availableForRepetition,
				isHidden: action.payload.isHidden,
			};
		case EditSubcategoryRestaurantPropertiesActionTypes.SET_DATA_FROM_RESTAURANT:
			return {
				...state,
				dishes: action.payload.dishes,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				availableForRepetition: action.payload.availableForRepetition,
				isHidden: action.payload.isHidden,
			};
		case EditSubcategoryRestaurantPropertiesActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditSubcategoryRestaurantPropertiesActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditSubcategoryRestaurantPropertiesActionTypes.TOGGLE_AVAILABLE_FOR_REPETITION:
			return {
				...state,
				availableForRepetition: !state.availableForRepetition,
			};
		case EditSubcategoryRestaurantPropertiesActionTypes.TOGGLE_IS_HIDDEN:
			return {
				...state,
				isHidden: !state.isHidden,
			};
		case EditSubcategoryRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditSubcategoryRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
